export enum ErrorTag {
  Label = "label",
  BoxlessReturn = "boxless-return",
  InstantRefund = "instant-refund",
  Pickup = "pickup",
  InStoreReturn = "in-store-return",
  ClaimReport = "claim-report",
  RepairInvoice = "repair-invoice",
}
